import { render, staticRenderFns } from "./GeneratedOrders.vue?vue&type=template&id=3c4b442e&scoped=true&"
import script from "./GeneratedOrders.vue?vue&type=script&lang=js&"
export * from "./GeneratedOrders.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedOrders.vue?vue&type=style&index=0&id=3c4b442e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b442e",
  null
  
)

/* custom blocks */
import block0 from "./GeneratedOrders.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports